module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/icon-kol@3x-1555a5cca3942e99a13452d66cd92d3c.png";